<template>
    <div v-if="flattenedRatesCount > 0" class="regel borderbottom lineheight28">
        <div v-if="cabin">
            <div style="height: 175px; max-height: 175px">
                <div class="hutImage floatleft width30">
                    <div class="marginleft15 marginright15 margintop15">
                        <div class="floatleft relative">
                            <img
                                :src="returnCorrectImage"
                                v-on:click="toggleModal"
                                class="width100 pointer cabin-image"
                            />
                            <div
                                v-if="showModal"
                                class="hutimage"
                                v-on:click="toggleModal"
                            >
                                <div class="cabin-image">
                                    <img :src="returnCorrectImage" />
                                </div>
                            </div>
                            <div
                                v-on:click="toggleFloorPlan"
                                class="marginright5 white pointer map-icon"
                                v-if="cabin.img_plattegrond_url"
                            >
                                <font-awesome-icon
                                    icon="map"
                                    class="marginright5"
                                />
                                {{ returnCorrectAction }}
                            </div>
                        </div>
                        <div class="clear"></div>

                        <div v-if="false" class="textcenter paddingtop10">
                            <h1 class="darkblue bold">
                                € {{ selectedRate.prijs }}
                                p.p.
                            </h1>

                            <button
                                v-on:click="changeHut"
                                class="button midblauwbg width100 rounded"
                            >
                                Wijzig huttype
                            </button>

                            <div
                                v-if="visableSelect"
                                class="floatleft margintop10"
                            >
                                <div class="select-drop floatleft">
                                    <select
                                        v-model="selectedRateIndex"
                                        class="selectpaddingsmall"
                                    >
                                        <RateOption
                                            v-for="(rate,
                                            index) in flattenedRates"
                                            :key="rate.id"
                                            :index="index"
                                            :rate="rate"
                                        />
                                    </select>
                                </div>
                            </div>
                        </div>
                        <!--                    <div class="clear"></div>-->

                        <!--                    <div-->
                        <!--                        class="floatleft margintop10 marginleft10"-->
                        <!--                        v-if="-->
                        <!--                            cabin.faciliteiten != null && cabin.faciliteiten.dek-->
                        <!--                        "-->
                        <!--                    >-->
                        <!--                        <b>Dekken: </b>{{ decksToString }}.-->
                        <!--                    </div>-->
                    </div>
                    <div class="clear"></div>
                </div>

                <div class="floatleft width60" id="hutdesc">
                    <div class=" margintop15 width100">
                        <div
                            class="darkblue bold marginbottom10 hutstyle"
                            style="font-size: 16px"
                        >
                            Hut {{ index }}:
                            {{ cabin.naam }}
                            {{ cabin.code }}
                        </div>

                        <div class="clear-both">
                            {{ cabin.omschrijving }}
                        </div>
                    </div>

                    <div class="clear"></div>

                    <p
                        v-if="flattenedRatesCount === 1"
                        class="font20 bold darkblue paddingleft15 paddingright10"
                    >
                        {{ cabin.naam }} {{ cabin.code }} {{ selectedRateName }}
                    </p>

                    <table
                        v-if="false"
                        class="optiontable paddingleft15 width100 paddingright10"
                    >
                        <!-- cabinCode faciliteiten USPS -->
                        <tr
                            v-for="(usps, index) in availableUSPSItems"
                            :key="'CabinFaciliteitenUsps' + index"
                            v-on:click="toggleShow(usps)"
                            :class="{ pointer: usps.detail !== '' }"
                        >
                            <td valign="top">
                                <font-awesome-icon
                                    :icon="validateIcon(usps.icon)"
                                    :class="usps.color"
                                />
                            </td>
                            <td align="left" valign="top" style="width: 96%;">
                                {{ usps.text }}
                                <font-awesome-icon
                                    v-if="usps.detail !== ''"
                                    icon="info"
                                    class="darkblue font10"
                                    style="vertical-align:  text-top;"
                                />
                                <div
                                    v-if="usps.showDetail"
                                    v-html="usps.detail"
                                    class="font10"
                                    style="line-height: 13px;"
                                ></div>
                            </td>
                        </tr>

                        <tr
                            v-for="(usps, index) in matchingRateCodeUspsItems"
                            :key="'matchingRateCodeUspsItems' + index"
                            v-on:click="toggleShow(usps)"
                            :class="{ pointer: usps.detail !== '' }"
                        >
                            <td valign="top">
                                <font-awesome-icon
                                    :icon="validateIcon(usps.icon)"
                                    :class="usps.color"
                                />
                            </td>
                            <td align="left" valign="top">
                                {{ usps.text }}
                                <font-awesome-icon
                                    v-if="usps.detail !== ''"
                                    icon="info"
                                    class="darkblue font10"
                                    style="vertical-align:  text-top;"
                                />
                                <div
                                    v-if="usps.showDetail"
                                    v-html="usps.detail"
                                    class="font10"
                                    style="line-height: 13px;"
                                ></div>
                            </td>
                        </tr>
                        <tr>
                            <td><!--empty cell--></td>
                        </tr>
                        <tr
                            v-if="cabin.isCampagne === selectedRate.rateCode"
                            style="color: deeppink;"
                        >
                            <td>
                                <font-awesome-icon
                                    icon="tags"
                                    style="font-weight: bold"
                                />
                            </td>
                            <td>
                                De actie "<span
                                    v-html="cabin.campagneTitle"
                                ></span
                                >" is van toepassing!
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="width100 paddingleft20 paddingright20">
                <h3 class="darkblue" style="font-size: 16px">Kies je actie:</h3>
                <div class="ratelist">
                    <CabinAvailable
                        v-for="rateCode in availableRates"
                        :key="rateCode.index"
                        :index="index"
                        :rateCode="rateCode"
                        :cabin="cabin"
                    />
                </div>
            </div>

            <div class="clear paddingtop15"></div>
        </div>
    </div>
    <div v-else="">
        <!-- @todo loading container and fail display on rate retrieval timeout -->
    </div>
</template>

<script>
import RateOption from './RateOption'
import CabinRate from './CabinRate'
import CabinAvailable from './CabinAvailable'

export default {
    name: 'Cabin.vue',
    components: {
        RateOption,
        CabinRate,
        CabinAvailable,
    },
    data: function() {
        return {
            floorPlanVisible: false,
            visableSelect: false,
            showModal: false,
            showAllRates: false,
        }
    },
    props: {
        index: Number,
    },
    computed: {
        cruiseID: function() {
            return this.$store.state.highlightedRate.cruiseID
        },
        flattenedRates: function() {
            return this.$store.getters.flattenedRates
        },
        availableRates: function() {
            let availableRates = []
            let cabinType = this.flattenedRates[this.selectedRateIndex].type
            this.$store.getters.flattenedRates.map(function(rate) {
                if (rate.type === cabinType)
                    if (!availableRates.includes(rate.rateCode)) {
                        availableRates.push(rate.rateCode)
                    }
            })
            return availableRates
        },
        flattenedRatesCount: function() {
            return Object.keys(this.flattenedRates).length
        },
        selectedRate: function() {
            return this.flattenedRates[this.selectedRateIndex]
        },
        selectedRateIndex: function() {
            return this.$store.state.cabinSetup[this.index - 1].rateSelectIndex
        },
        cabin: function() {
            if (this.selectedRate)
                return this.$store.getters.cabinDetail(
                    this.selectedRate.cabinCode
                )
            return false
        },
        selectedRateName: function() {
            return this.$store.getters.rateName(this.selectedRate.rateCode)
        },
        departures: function() {
            return this.$store.state.departures
        },
        highlightedRate: function() {
            return this.$store.state.highlightedRate
        },
        cruise: function() {
            return this.$store.state.cruise
        },
        deckNames: function() {
            return this.$store.state.deckNames
        },
        returnCorrectImage: function() {
            if (this.floorPlanVisible) {
                return this.cabin.img_plattegrond_url
            }
            return this.cabin.img_url
        },
        returnCorrectAction: function() {
            if (this.floorPlanVisible) {
                return 'Hut'
            } else {
                return 'Plattegrond'
            }
        },
        decksToString: function() {
            if (
                !this.cabin.faciliteiten ||
                !this.cabin.faciliteiten.dek ||
                !this.deckNames
            ) {
                return null
            }
            let self = this
            let dekStr = self.cabin.faciliteiten.dek
            let dekArr = dekStr.split(',')
            let nameArr = []
            if (typeof dekArr === 'object') {
                dekArr.forEach(function(dek) {
                    let dkNr = dek.trim()
                    if (dkNr in self.deckNames) {
                        nameArr.push(self.deckNames[dkNr])
                    }
                })
            }

            return nameArr.join(', ')
        },
        availableUSPSItems: function() {
            if (
                this.cabin !== {} &&
                this.cabin.faciliteiten &&
                this.cabin.faciliteiten.usps
            ) {
                return this.cabin.faciliteiten.usps.filter(function(item) {
                    return item.text !== ''
                })
            }
            return []
        },
        matchingRateCodeUspsItems: function() {
            if (
                this.cruise &&
                this.cruise.ratecode_usps &&
                this.cruise.ratecode_usps.rates &&
                this.cabin !== {}
            ) {
                let rateCode = this.selectedRate.rateCode

                let ret = this.cruise.ratecode_usps.rates.find(function(usps) {
                    return usps.rateCode === rateCode && usps.text !== ''
                })

                if (ret && ret.uspsItems) {
                    return ret.uspsItems
                }
            }
            return []
        },
    },
    methods: {
        changeHut: function() {
            this.visableSelect = !this.visableSelect
        },
        showAllRate: function() {
            this.showAllRates = !this.showAllRates
        },
        validateIcon: function(icon) {
            if (icon === '') {
                return 'check'
            }
            return icon
        },
        toggleShow: function(val) {
            if (val.detail === '') return false

            val.showDetail = !val.showDetail

            if (val.icon === 'plus') {
                val.icon === 'min'
            }
            if (val.icon === 'min') {
                val.icon === 'plus'
            }
        },
        toggleFloorPlan: function() {
            this.floorPlanVisible = !this.floorPlanVisible
        },
        toggleModal: function() {
            this.showModal = !this.showModal
        },
    },
}
</script>

<style scoped>
.availablerates {
    padding: 1px;
    cursor: pointer;

    border: 1px solid #f4fcfe;
    display: flex;
    width: calc(100% - 40px);
}
.availablerates .availableratesinfo {
    width: calc(100% - 150px);
    padding: 10px;
}
.availablerates .availableratesprijs {
    width: 150px;
    line-height: 42px;
    text-align: right;
    font-size: 16px;
    padding-right: 10px;
    font-weight: bold;
}
.rateselected {
    background: #37b5d3;
}
.rateselected div {
    color: white !important;
}

.hutimage {
    position: fixed;
    width: 100%;
    height: 100vh;

    background: rgba(0, 0, 0, 0.4);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
}
.hutimage div {
    max-width: 700px;
    width: 100%;
    margin: 25vh auto;
    border-radius: 15px;
}
.map-icon {
    position: absolute;
    margin-left: 10pt;
    margin-top: 10pt;
    color: #000 !important;
    background-color: #fff;
    padding: 3pt 7pt;
    border-radius: 3pt;
    font-size: 0.7em;
    -webkit-box-shadow: 0 0 5pt 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 5pt 0 rgba(0, 0, 0, 0.5);
}

.borderbottom {
    border-bottom: 1pt solid #eee;
}

.cabin-image {
    border-radius: 5pt;
}
</style>
